import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import ExoTable from '../exo/ExoTable';
import { useTranslation } from 'react-i18next';
import ExoTableRecipient from '../exo/ExoTableRecipient';
import DBSearch from '../special/DBSearch';
import useFetch from '../../api/useFetch';

const SelectDeliveryNote = ({
  apiUrl,
  onSelect,
  filter = '',
  selected = {},
  useSearch = false,
}) => {
  const { t } = useTranslation();

  // Search mode state
  const [searchResults, setSearchResults] = useState(null);

  // API mode state
  const { apiData, isLoading } = useFetch(
    !useSearch ? apiUrl || `delivery-notes?${filter}` : null,
  );

  //tabel
  const Columns = [
    {
      header: t('Nr'), // header of column
      key: 'nr', // key of column in row-object
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      width: '100px', // width of column
      cell: ({ row }) => (
        <Box className="monospace whitespace-nowrap">
          {row.nr ?? t('Draft')}
        </Box>
      ), // custom xml for cells in the column. you get the row as object
      onClick: (row) => onSelect(row),
    },
    {
      header: t('Title'), // header of column
      key: 'title', // key of column in row-object
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      width: 'auto', // width of column
      onClick: (row) => onSelect(row),
    },
    {
      header: t('Recipient'), // header of column
      key: 'recipient', // key of column in row-object
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      width: 'auto', // width of column
      cell: ({ row }) => <ExoTableRecipient row={row} />, // custom xml for cells in the column. you get the row as object
      onClick: (row) => onSelect(row),
      hiddenMobile: true,
    },
    {
      header: t('Products'), // header of column
      key: 'itemCount', // key of column in row-object
      thAlign: 'right', // header text alignment
      tdAlign: 'right', // cell text alignment
      width: '170px', // width of column
      hiddenMobile: true,
      cell: ({ row }) => (
        <Typography className=" monospace">{row.itemCount}</Typography>
      ), // custom xml for cells in the column. you get the row as object
      onClick: (row) => onSelect(row),
    },
  ];

  if (!useSearch) {
    return (
      <ExoTable
        className="h-full w-full"
        data={apiData}
        isLoading={isLoading}
        columns={Columns}
      />
    );
  }

  return (
    <DBSearch
      param="delivery-notes"
      onSearch={(res) => setSearchResults({ data: res })}
    >
      <ExoTable
        className="h-full w-full"
        data={searchResults}
        isLoading={!searchResults}
        columns={Columns}
      />
    </DBSearch>
  );
};

export default SelectDeliveryNote;
